module.exports = __webpack_public_path__ + "media/images/ibjjf/academy_registration_informations/kids_tournaments-81973e04b3b293919977e2d06374fdca.svg";